import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, QrCode, Store } from 'lucide-react';
export function Slide13RedeemPartners() {
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-166">
      <motion.h2 className="text-5xl font-bold text-[#ffd700] mb-16 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-167">
        Redeem Partners
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-168">
        <div className="relative h-96 bg-white/5 rounded-3xl border border-white/10 overflow-hidden" data-id="element-169">
          {/* Map Visualization */}
          <div className="absolute inset-0 opacity-30 bg-[url('https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Sweden_location_map.svg/800px-Sweden_location_map.svg.png')] bg-cover bg-center" data-id="element-170" />

          {/* Dropping Pins */}
          {[...Array(8)].map((_, i) => <motion.div key={i} className="absolute text-[#ffd700]" style={{
          left: `${20 + Math.random() * 60}%`,
          top: `${20 + Math.random() * 60}%`
        }} initial={{
          y: -50,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: i * 0.2,
          type: 'spring'
        }} data-id="element-171">
              <MapPin className="w-8 h-8 fill-current" data-id="element-172" />
            </motion.div>)}
        </div>

        <div className="space-y-8" data-id="element-173">
          {[{
          icon: Store,
          text: '10+ partners ready for pilot'
        }, {
          icon: QrCode,
          text: 'QR code at checkout - no logistics'
        }, {
          icon: MapPin,
          text: 'Nationwide from day 1'
        }].map((item, i) => <motion.div key={i} initial={{
          x: 50,
          opacity: 0
        }} animate={{
          x: 0,
          opacity: 1
        }} transition={{
          delay: 0.5 + i * 0.2
        }} className="flex items-center gap-6 p-6 rounded-xl bg-white/5 border border-white/10" data-id="element-174">
              <item.icon className="w-8 h-8 text-[#4fd1c5]" data-id="element-175" />
              <span className="text-xl font-medium text-white" data-id="element-176">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}